<template>
  <div class="payIndex">
    <div class="flex_start mb">
      <div class="select-part">
        <el-date-picker
          v-model="timeRang"
          type="daterange"
          :range-separator="$t('payList.dash')"
          align="left"
          value-format="yyyy-MM-dd"
          :start-placeholder="$t('payList.date')"
          :end-placeholder="$t('payList.range')"
          @change="getData">
        </el-date-picker>
      </div>
    </div>
      <el-table
      :data="paymentData"
      :empty-text="$t('global.noData')"
      style="width: 100%">
      <el-table-column
        prop="order_no"
        :label="$t('payList.orderNo')">
      </el-table-column>
      <el-table-column
        prop="created_at"
        :label="$t('payList.dateTitle')">
      </el-table-column>
      <el-table-column
        prop="price"
        :label="$t('payList.paid')">
        <template slot-scope="scope">
         <span v-text="utils.numFormat(scope.row.price)"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="quantity"
        :label="$t('payList.credits')">
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pagenum"
      :page-size="pagesize"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    dataPayment: Object,
    required: true
  },
  data () {
    return {
      timeRang: Array.apply(null, Array(2)).map(() => ''),
      paymentData: [],
      pagenum: 1, // 当前页码
      pagesize: 10, // 每页显示条数
      total: 0
    }
  },
  created () {
    this.getData()
    this.paymentData = this.dataPayment.data
    this.total = this.dataPayment.total
  },
  methods: {
    getData () {
      if (!this.timeRang) {
        this.timeRang = Array.apply(null, Array(2)).map(() => '')
      }
      this.$http.get('/api/account-logs/recharge?start_at=' + this.timeRang[0] +
      '&end_at=' + this.timeRang[1] + '&time_diff=' + this.utils.timeZone() +
      '&pagesize=' + this.pagesize +
       '&page=' + this.pagenum).then((res) => {
        if (res.data.code == 200) {
          this.paymentData = res.data.data
          this.total = res.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange (val) {
      this.pagenum = val
      this.getData()
    }
  }
}
</script>
<style lang="less" scoped>
  .payIndex{

    .mb{
      margin-bottom:20px;
    }
    ::-webkit-input-placeholder { /* WebKit browsers */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    :-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    ::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }

    :-ms-input-placeholder { /* Internet Explorer 10+ */
      color: #6B6B6B!important;
      font-size: 14px;
      font-family: Sofia Pro-Regular;
    }
    .select-part{
      margin-right: 20px;
    }
      // 日历
      /deep/ .el-date-editor--daterange{
        width:230px;
        height:40px;
        border:none;
        border-bottom: 1px solid #a5a5a5;
        border-radius: 0;
        input,span{
          line-height: 35px;
        }
        input{
          width: 45%;
          text-align: left;
        }
        .el-range-separator{
          color:#979797;
          font-size: 14px;
          font-family: Sofia Pro-Regular;
        }
        .el-icon-date{
          display: none;
        }

      }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/payment.vue